import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string) =>
    <path
        d="M9 6.33765V9.33765M9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 12.7279 12.7279 15.75 9 15.75ZM9.03735 11.5876V11.6626L8.96265 11.6624V11.5876H9.03735Z"
        stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>

export const CircleWarning: React.FC<IconProps> = ({color, size, className}) => (
    <IconWrapper viewBox={`0 0 ${parseInt(size)} ${parseInt(size)}`} {...{size, color, className, renderIcon}} />
)
